<template>

  <v-card style="margin:8px; overflow: auto;">
    <v-card-title>
      <v-layout fluid>

        <!-- title -->
        <v-flex fluid>
          <span
            v-if="plate !== null"
            style="white-space: nowrap; width: 70%;"
          >{{ plate.name }}</span>
          <span v-else>no plate {{ plate_id }}</span>

          <!-- state -->
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon v-on="on" style="margin-left: 8px;">mdi-cog</v-icon>
            </template>
            <template #default>
              <pre>{{ JSON.stringify(state, null, 2) }}</pre>
            </template>
          </v-tooltip>

        </v-flex>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" style="margin-left: 16px;" disabled>
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <template #default>
            <span>Delete all plate wells from probe spectra source</span>
          </template>
        </v-tooltip>

      </v-layout>

    </v-card-title>
    <v-card-text>
      <table v-if="plate !== null">
        <tr v-for="(row, row_i) in plate_frame.rows"
            :key="row_i">
          <td v-for="(col, col_i) in plate_frame.cols"
              :key="col_i">

            <v-tooltip top>
              <template #activator="{ on }">
                <div
                  v-on="on"
                  :style="get_well_style(row_i, col_i)"
                ></div>
              </template>
              <template #default>
                <span>{{ get_well_title(row_i, col_i) }}</span>
              </template>
            </v-tooltip>

          </td>
        </tr>
      </table>
    </v-card-text>

  </v-card>

</template>

<script>

	import format from 'string-format'
	import {mapGetters, mapActions} from 'vuex'

	import {plate96_frame} from "../../models/plate_frame"
	import Vue from 'vue'

	export default {
		name: "plate-wells",
		components: {},

		data: function () {
			return {
				plate: null,
				plate_frame: null,
			}
		},

		props: {
			well_color: {type: String, default: () => 'green',},
			plate_id: {type: Number, default: -1,},
			well_num_list: {type: Array, default: () => [],},
		},

		computed: {
			...mapGetters({
				plates: 'plate/plates',

			}),

			state: function () {
				return {
					component: this.$options.name,
					plate_id: this.plate_id,
					well_num_list: this.well_num_list,
					'plate.ctor.name': this.plate !== null
						? this.plate.constructor.name
						: null,
					well_color: this.well_color,
				}
			},
		},

		watch: {
			plate_id: function () {
				this.update_view()
			},

			well_num_list: function () {
				console.debug("PlateWellsComponent.watch.well_num_list()")
			},
		},

		mounted: function () {
			// маленький костыль для первой отрисовки компонента
			this.update_view()
		},

		methods: {

			update_view: function () {

				// костыль хард-код
				this.plate_frame = plate96_frame

				this.plate = this.plate_id !== -1
					? this.plates[this.plate_id]
					: null

				let k = 11
			},

			get_well_style: function (row_i, col_i) {
				const well_num = row_i * this.plate_frame.cols.length + col_i

				const color = this.well_num_list.indexOf(well_num) !== -1
					? this.well_color
					: 'gray'

				console.debug(format(
					"PlateWellsComponent.get_well_style()\n  {0}",
					JSON.stringify({color: color})
				))

				return {
					width: "12px",
					height: "12px",
					'background-color': color,
				}
			},

			get_well_title: function (row_i, col_i) {
				return format("{R}{C}", {
					R: this.plate_frame.rows[row_i].title,
					C: this.plate_frame.cols[col_i].title,
				})
			},
		}
	}
</script>

<style scoped>

</style>